<template>
  <v-dialog persistent max-width="60%">
    <v-card class="pa-4">
      <v-card-title class="d-flex justify-space-between align-center">
        New Inventory Item
        <v-spacer></v-spacer>
        <v-btn
          variant="text"
          icon="mdi-close"
          @click="() => $emit('update:modelValue', false)"
          class="close-button"
        />
      </v-card-title>

      <v-card-text class="pa-0 ma-0">
        <InventoryItemCreationStepper
          ref="stepper"
          @submit="$emit('create', $event)"
        ></InventoryItemCreationStepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import InventoryItemCreationStepper from "./InventoryItemCreationStepper.vue";
export default {
  name: "InventoryItemCreateDialog",
  components: {
    InventoryItemCreationStepper,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "create"],
  data() {
    return {};
  },
  computed: {},

  watch: {},

  created() {
    console.log("Dialog created");
  },
};
</script>